import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import UpdateItemResponse from 'owa-service/lib/contract/UpdateItemResponse';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(itemIdToUpdate: string, itemUserHighlights: string[]) {
    const update = createSetItemField('UserHighlightData', itemUserHighlights);
    const singleItemChange = itemChange({
        Updates: [update],
        ItemId: itemId({ Id: itemIdToUpdate }),
    });

    return updateItemRequest({
        ItemChanges: [singleItemChange],
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

export default function saveHighlightService(
    itemId: string,
    itemUserHighlights: string[]
): Promise<UpdateItemResponse> {
    const requestBody = createRequestBody(itemId, itemUserHighlights);

    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
